export default __webpack_public_path__ + "static/media/ic-logonegative.ec9f065f.svg";